import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3d6810e8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f19312fa = () => interopDefault(import('../pages/immobili/index.vue' /* webpackChunkName: "pages/immobili/index" */))
const _f500558a = () => interopDefault(import('../pages/immobili/_slug.vue' /* webpackChunkName: "pages/immobili/_slug" */))
const _40d55378 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _3d6810e8,
    name: "index___en"
  }, {
    path: "/immobili",
    component: _f19312fa,
    name: "immobili___it"
  }, {
    path: "/en/villas-and-apartments",
    component: _f19312fa,
    name: "immobili___en"
  }, {
    path: "/en/villas-and-apartments/:slug",
    component: _f500558a,
    name: "immobili-slug___en"
  }, {
    path: "/en/:slug",
    component: _40d55378,
    name: "slug___en"
  }, {
    path: "/immobili/:slug",
    component: _f500558a,
    name: "immobili-slug___it"
  }, {
    path: "/",
    component: _3d6810e8,
    name: "index___it"
  }, {
    path: "/:slug",
    component: _40d55378,
    name: "slug___it"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
